import stylesheet from './loading-indicator.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTLoadingIndicator extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get label(): string {
        return this.getAttribute('label') ?? 'Loading';
    }

    get size(): string {
        return this.getAttribute('size') ?? '40';
    }

    render() {
        const element = document.createElement('span');
        element.classList.add('loading-indicator');
        element.setAttribute('role', 'status');
        element.setAttribute('aria-label', this.label);
        element.style.setProperty('--size', `${this.size}px`);
        element.innerHTML = `
            <svg class="spinner" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <circle class="track" cx="20" cy="20" r="18.5" stroke-width="3"></circle>
                <path class="arc" stroke-width="3" d="M7.70712 33.8252C4.90064 31.3297 2.92008 28.0393 2.02869 24.3911C1.1373 20.743 1.3773 16.9099 2.71679 13.4015C4.05628 9.89301 6.43182 6.87529 9.52766 4.74943C12.6235 2.62356 16.293 1.49023 20.0485 1.50006"></path>
            </svg>
        `;
        return element;
    }

}

customElements.define('nxt-loading-indicator', NXTLoadingIndicator);
